// extracted by mini-css-extract-plugin
export default {"bucketContainer":"Bucket_bucketContainer__VnwXz","bucketCard":"Bucket_bucketCard__9SzLS","cardBtns":"Bucket_cardBtns__HLTsH","editButton":"Bucket_editButton__sFcwz"};